import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <section className="wrap py-32" data-testid="not-found">
      <p className="eyebrow">§ 404</p>
      <h1 className="display mt-4 text-5xl font-medium sm:text-6xl">
        Page not found.
      </h1>
      <p className="mt-5 max-w-lg text-[16px] text-ink-700">
        The page you're looking for doesn't exist — possibly retired, possibly
        never built. Head back home, or write to Roman directly.
      </p>
      <div className="mt-8 flex gap-3">
        <Link to="/" className="btn-primary" data-testid="404-home">
          ← Home
        </Link>
        <Link to="/contact" className="btn-outline" data-testid="404-contact">
          Contact
        </Link>
      </div>
    </section>
  );
}
